// ./Pages/PortalChooser/PortalChooser.js
// Reached only via Authentication.isLoggedIn()/Login.js/Dashboard.js's own
// redirects, when this login has nothing to act on cpv2 at all (empty
// userData2 -- see Authentication.login's own comment for why that's a
// real, reachable state, not just hypothetical). Its own page, not folded
// into Dashboard/Navbar -- every nav link there (Search, History,
// Accounting) would be a dead end with no carrier context to act against.
// No Navbar at all here; Log Out is its own explicit link since that's the
// one thing from Navbar still genuinely needed. Mirrors carrier-portal-
// frontend-3's NoPortalAccessPage.jsx as closely as this app's own
// conventions (class components, no i18n, Bootstrap 4 utility classes)
// allow.

import React, { Component } from "react";
import Authentication from "../../APIs/Authentication";
import CrossPortalCards from "../../Components/CrossPortalCards";
import "./PortalChooser.css";

class PortalChooser extends Component {
  constructor() {
    super();
    this.handleLogOut = this.handleLogOut.bind(this);
    this.state = {
      notice: Authentication.getCrossPortalNotice(),
    };
  }

  componentDidMount() {
    // Same session/expiry check as every other page -- a direct visit here
    // with no (or an expired) session goes to /Login instead of showing
    // "Nothing to show here".
    Authentication.isLoggedIn();
  }

  handleLogOut() {
    Authentication.logOut();
  }

  render() {
    const titilliumStyle = {
      fontFamily: "Titillium Web, Semibold",
      fontWeight: "600",
      fontSize: "2.9rem",
      marginBottom: "2vh",
    };
    const { notice } = this.state;

    return (
      <div className="Login">
        <div className="loginChildLogo">
          <img src="shippersedge-logo.png" alt="logo" height="100px" />
          <br />
        </div>
        <div className="signInTxt">
          <h2 style={titilliumStyle}>Carrier Portal</h2>
        </div>
        <div className="portalChooserContent">
          {notice ? (
            <>
              <h3>Carrier Portal: Legacy Version &amp; New Version</h3>
              <div className="portalChooserExplanation">{notice.explanation.en}</div>
              <CrossPortalCards
                thisPortalClients={[]}
                otherPortalClients={notice.otherPortalClients}
                otherPortalUrl={notice.otherPortalUrl}
              />
            </>
          ) : (
            <>
              <h3>Nothing to show here</h3>
              <p className="text-muted">
                No carriers or clients are currently available on this account. Please contact
                your customer or ShippersEdge support if you believe this is a mistake.
              </p>
            </>
          )}
          <div className="portalChooserLogoutRow">
            <a href="#" className="textLikeAHyperLink" onClick={(e) => { e.preventDefault(); this.handleLogOut(); }}>
              Log Out
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default PortalChooser;
